module.exports = __webpack_public_path__ + "static/media/icon_processing_blue.a800d8eb.svg";